export default __webpack_public_path__ + "static/media/live-courses-icon.a8c1266a.svg";